import { Environment } from 'src/app/shared/models/api/enum';
import { EnvironmentSettings } from 'src/app/shared/models/app/model';

export const environment: EnvironmentSettings = {
  appInsightsConnectionString:
    'InstrumentationKey=0b40de87-135c-4d17-80f2-9830e66848ef;IngestionEndpoint=https://westus2-2.in.applicationinsights.azure.com/;LiveEndpoint=https://westus2.livediagnostics.monitor.azure.com/',
  auth: {
    authorityDomain: 'aegispremierdev.b2clogin.com',
    clientId: '584c1dac-24e0-4862-8a46-b45a5cb8f068', // Maps to Azure AD B2C application (client) ID
    domainName: 'aegispremierdev.onmicrosoft.com',
    signInPolicy: 'B2C_1A_SIGNUP_SIGNIN',
  },
  envName: Environment.Development,
  fecApiEndpoint: 'https://fecapi-dev.aegispremier.com',
  production: false,
};
